import de from 'dayjs/locale/de'

const locale: ILocale = {
  ...de,
  name: 'de',
  weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
  weekStart: 0,
  weekdaysShort: 'Mo_Di_Mi_Do_Fr_Sa_So'.split('_'),
  monthsShort: 'Jan_Feb_März_Apr_Mai_Juni_Juli_Aug_Sep_Okt_Nov_Dez'.split('_'),
  weekdaysMin: 'Mo_Di_Mi_Do_Fr_Sa_So'.split('_'),
  ordinal: (n) => n
}

export default locale
